import { VERSION_TABLE } from '../constants/content';

export default function VersionTable() {
  return (
    <div className="table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            <th scope="col">Edition</th>
            <th scope="col">Year</th>
            <th scope="col">What changed</th>
          </tr>
        </thead>
        <tbody>
          {VERSION_TABLE.map((row) => (
            <tr key={row.version}>
              <td>{row.version}</td>
              <td>{row.released}</td>
              <td>{row.note}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
